/**
 * @package dto
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CreateRateData
 */

export class CreateRateData {
  public resourceId!: number;

  public buildingId?: number;

  public accountId?: number;

  public price!: number;
}
